import React from "react";
import { getIcon, zeroPad } from "./Functions";

export const SpinLoader = ({ loading = false }) => {
	if (loading)
		return (
			<div className="loading-overlay">
				<div className="has-loader has-loader-active">
					<div className="h-loader-wrapper">
						<div className="loader is-small is-loading" />
					</div>
				</div>
			</div>
		);
	else return <div />;
};


export const PageLoader = ({ loading=true }) => {
	return (
		<>
		<div className={`pageloader ${loading ? "is-active" : ""} w-100`} style={{ left: 0 }} />
		<div className={`infraloader ${loading ? "is-active" : ""} w-100`} style={{ left: 0 }} />
		</>
	)
}


export const CallToAction = ({ className }) => {
	return <div/>
	return (
		<div className={"my-6 "+className}>
  <div 
	className="background-cta" 
	data-background="https://dummyimage.com/1920x1080" 
	data-demo-background={require("../assets/images/cta-bg-1.jpeg").default} 
	style={{ backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundImage: `url("${require("../assets/images/cta-bg-1.jpeg").default}")` }}
	>
    <div className="columns">
      <div className="column is-4">
        <h4 className="title is-3 is-bold text-inverted has-space">
			Earn real money by doing what you like the most.
        </h4>
        <p className="text-inverted">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maximus
          dolor, inquit, brevis est. Comprehensum, quod cognitum non habet?
        </p>
        <div className="py-4">
          <a className="button is-primary is-raised-hover">Become our Specialist</a>
        </div>
      </div>
    </div>
  </div>
</div>

	)
}


export const DatePicker = ({ callback, type }) => {
	const el = React.useRef(null);
	React.useEffect(() => {
		if(type === 2){
			// eslint-disable-next-line no-undef
			var picker = new Pikaday({
				field: el.current,
				format: 'D MMM YYYY',
				// onSelect: function(e) {
				// 	//Do your stuff
				// 	// const value = el.current.value;
				// 	console.log(e)
				// }
			});
		}else{
			// eslint-disable-next-line no-undef
			bulmaCalendar.attach(el.current, {
				displayMode: 'dialog',
				startDate: new Date(),
				lang: 'en'
			});
			el.current.bulmaCalendar.on("select", function (datepicker) {
				// updateBooking({ date_time: datepicker.data.value() });
				const d = new Date(datepicker.data.value());
				const date = `${d.getFullYear()}-${zeroPad(d.getMonth() + 1)}-${zeroPad(d.getDate())}`;
				callback && callback(date)
			})

			const clear = document.getElementsByClassName("datetimepicker-clear-button")
			if(clear.length > 0){
				clear.item(0).addEventListener("click", () => {
					callback && callback("")
				})
			}
		}
	}, [])
	if(type === 2){
		return (
			<div className="field">
  <div className="control has-icon">
    <input id="pickaday-datepicker" onInput={e => alert(e.target.value)} ref={el} className="input" placeholder="select a date" />
    <div className="form-icon" dangerouslySetInnerHTML={{ __html: getIcon("calendar") }}>
    </div>
  </div>
</div>

		)
	}
	return (
		<input
			ref={el}
			className="w-100 input custom-text-filter"
			type="date"
			style={{ minHeight: 45 }}
		/>
	)
}
